export const getMonthObserver = (rootElement, options) => {
  return new MutationObserver(() => {
    const yearSelectedInHeader = rootElement.querySelector(`.react-datepicker__year-read-view--selected-year`)
    const monthDropdown = rootElement.querySelector(`.react-datepicker__month-dropdown`)

    if (options?.custom?.datePickerParams) {
        const { dateMinValue, dateMaxValue } = options?.custom?.datePickerParams
        if (monthDropdown) {
          const monthDropdownMonths = rootElement.querySelectorAll(`.react-datepicker__month-dropdown .react-datepicker__month-option`)

          const disableMonths = (i) => {
            monthDropdownMonths[i].classList.add("disabled")
            monthDropdownMonths[i].onclick = (event) => {
              event.preventDefault();
              event.stopPropagation();
              return false;
            }
          }

          if (dateMinValue.includes(yearSelectedInHeader.innerHTML)) {
            const minMonth = dateMinValue.split('-')[1]
            for (let i = 0; i < monthDropdownMonths.length; i++) {
              if (i +1 < Number(minMonth)) {
                disableMonths(i)
              }
            }
          }

          if (dateMaxValue.includes(yearSelectedInHeader.innerHTML)) {
            const maxMonth = dateMaxValue.split('-')[1]
            for (let i = 0; i < monthDropdownMonths.length; i++) {
              if (i +1 > Number(maxMonth)) {
                disableMonths(i)
              }
            }
          }
        }
      }
  })
}

const stopPropagationAndClick = (el, elDropdown, event) => {
  event.stopPropagation()
  if (elDropdown) {
    setTimeout(() => el && el.click && el.click(), 100)
  }
}

export const getYearsObserver = (rootElement) => {
  return new MutationObserver((mutationsList, observer) => {
    const month = rootElement.querySelector(`.react-datepicker__month-read-view`)
    const year = rootElement.querySelector(`.react-datepicker__year-read-view`)

    const yearTitle = rootElement.querySelector(`.react-datepicker__year-read-view--selected-year`)
    const monthTitle = rootElement.querySelector(`.react-datepicker__month-read-view--selected-month`)

    const yearSelected = rootElement.querySelector(`.react-datepicker__year-option--selected_year`)
    const yearDropdown = rootElement.querySelector(`.react-datepicker__year-dropdown`)

    const monthDropdown = rootElement.querySelector(`.react-datepicker__month-dropdown`)

    for(const mutation of mutationsList) {
      if (year) {
        year.onmousedown = stopPropagationAndClick.bind(this, monthTitle, monthDropdown)
      }

      if (month) {
        month.onmousedown = stopPropagationAndClick.bind(this, yearTitle, yearDropdown)
      }

      if (mutation.type === 'attributes' && mutation.target === year) {
        if (yearDropdown) {
          const positions = yearSelected ? yearSelected.offsetTop : 0
          yearDropdown.scroll(300, positions-150)
        }
      }

      if (mutation.type === 'attributes' && mutation.target === year) {
        if(year.style.cssText === "visibility: hidden;") {
          yearTitle.className = `${yearTitle.className} selected`
        } else if (year.style.cssText === "visibility: visible;") {
          yearTitle.className = 'react-datepicker__year-read-view--selected-year'
        }

      }
      else if (mutation.type === 'attributes' && mutation.target === month) {
        if(month.style.cssText === "visibility: hidden;") {
          monthTitle.className = `${monthTitle.className} selected`
        } else if (month.style.cssText === "visibility: visible;") {
          monthTitle.className = 'react-datepicker__month-read-view--selected-month'
        }
      }
    }
  })
}

export const getMobileHeaderObserver = (rootElement, t, size, setDatePickerState, setTimePickerState) => {
  return new MutationObserver( (mutations) => {
    const time = rootElement.querySelector(`.react-datepicker__time-container`)
    const date = rootElement.querySelector(`.react-datepicker__month-container`)

    const popperWrapper = rootElement.querySelector(`.react-datepicker-popper`)
    const mobilePopper = rootElement.querySelector(`.opened-mobile-popper`)
    const refChild = rootElement.querySelector(`.react-datepicker`)

    const head = document.createElement('div')
    const titleEl = document.createElement('div')
    const closeButtonEl = document.createElement('div')

    closeButtonEl.innerHTML = '✕'
    closeButtonEl.className = 'delete-icon'

    if (date) {
      titleEl.innerHTML = t('ducs.set_date')
      closeButtonEl.onclick = () => setDatePickerState(false)
    }

    if (time) {
      titleEl.innerHTML = t('ducs.set_date')
      closeButtonEl.onclick = () => setTimePickerState(false)
    }

    head.className = 'opened-mobile-popper'
    head.appendChild(titleEl)
    head.appendChild(closeButtonEl)

    head.onclick = function () {
      refChild.parentNode.removeChild(head)
    }

    if (popperWrapper && (window.innerWidth <= Number(size))) {
      if (!mobilePopper) {
        refChild.parentNode.insertBefore(head, refChild)
      }
    }

    if (!popperWrapper && !!head) {
      rootElement.childNodes.forEach((item) => {
        if (item.className === 'opened-mobile-popper') {
          refChild.parentNode.removeChild(item)
        }
      })
    }
  })
}
